import { getExperimentVersion } from './getExperimentVersion';

const addExperimentVersionToUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set('experiment_version', getExperimentVersion());
    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return url;
  }
};

export default addExperimentVersionToUrl;
